(function () {
  'use strict';

  function init() {
    var slots = document.querySelectorAll('[data-renneway-campaign-slot][data-product-handle]');
    if (!slots.length) return;

    var handles = [];
    var byHandle = {};
    slots.forEach(function (el) {
      var h = (el.getAttribute('data-product-handle') || '').trim();
      if (!h) return;
      if (!byHandle[h]) byHandle[h] = [];
      byHandle[h].push(el);
      if (handles.indexOf(h) === -1) handles.push(h);
    });
    if (!handles.length) return;

    var base = (window.RENNEWAY_API_BASE || '').replace(/\/+$/, '');
    if (!base) return;

    // Chunk handles (URL length limit) — max 100 per call.
    var chunks = [];
    for (var i = 0; i < handles.length; i += 100) chunks.push(handles.slice(i, i + 100));

    Promise.all(chunks.map(function (chunk) {
      return fetch(base + '/api/public/campaign-flags?handles=' + encodeURIComponent(chunk.join(',')), {
        credentials: 'omit'
      }).then(function (r) { return r.ok ? r.json() : { campaigns: [] }; })
        .catch(function () { return { campaigns: [] }; });
    })).then(function (results) {
      results.forEach(function (res) {
        (res.campaigns || []).forEach(function (c) {
          var targets = byHandle[c.handle];
          if (!targets) return;
          targets.forEach(function (slot) {
            if (slot.querySelector('.product--badge.renneway-campaign')) return;
            var span = document.createElement('span');
            span.className = 'product--badge renneway-campaign';
            // Bilinen EN kampanya etiketleri (Hot Deal, New Arrival, ...) TR locale'inde
            // window.rnwCampaign() ile cevrilir. Custom label varsa olduğu gibi gozukur.
            var _rawLabel = c.badge || 'SALE';
            span.textContent = (window.rnwCampaign ? window.rnwCampaign(_rawLabel) : _rawLabel);
            slot.insertBefore(span, slot.firstChild);
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
